/**
 * @file paddle model detail
 * @author wanzhongyun
 */

import * as React from 'react';

// import Header from '../../components/header/HeaderWithStore';
// import Footer from '../../components/footer/footer';
// import { Detail } from '@baidu/ai-studio-component-modelcenter';
// import { ENV } from '@baidu/ai-studio-store-modelcenter';
// import RightNavigation from '../../components/right-navigation/RightNavigation';
const ModelCenterDetail: React.FC = () => {
    return (
        <div>
            {/* <Header /> */}
            {/* <div className="paddle-model-detail">
                <Detail
                    prefixApi="modelcenter"
                    env={ENV.paddle}
                    useId={0}
                    projectId={0}
                    aistudioLoginHandler={() => {}}
                    host="https://sandbox-aistudio.baidu.com"
                />
            </div>
            <RightNavigation />
            <Footer /> */}
        </div>
    );
};

export default React.memo(ModelCenterDetail);
